export const getPageItems = ({
  currentPageNum,
  maxPageNum,
  maxPageItemsCount,
}) => {
  const pageItems = []

  let lmod = 0
  let rmod = 0

  // NOTE: flexible maxPageItemsCount could be achived with
  // maxMod = maxPageItemsCount - 3 (1, cur and max)
  // rmod = maxMod - lmod
  // but, what happens on even maxNumber?

  if (currentPageNum === maxPageNum) {
    lmod = 2
  } else if (currentPageNum === 1) {
    rmod = 2
  } else if (currentPageNum <= 1 + 1 || currentPageNum >= maxPageNum - 1) {
    lmod = 1
    rmod = 1
  }

  const lborder = maxPageNum <= maxPageItemsCount ? 1 : currentPageNum - lmod
  const rborder =
    maxPageNum <= maxPageItemsCount ? maxPageNum : currentPageNum + rmod

  let page = 1
  while (page <= maxPageNum) {
    let pushValue
    if (page === 1 || page === maxPageNum) {
      pushValue = page
      page += 1
    } else if (page < lborder && lborder !== 2) {
      pushValue = null
      page = lborder
    } else if (page > rborder && rborder !== maxPageNum - 1) {
      pushValue = null
      page = maxPageNum
    } else {
      pushValue = page
      page += 1
    }
    pageItems.push(pushValue)
  }

  return pageItems
}

export const getEventHandler = (handler, index, callback = null) => {
  if (typeof callback === 'function') {
    callback()
  }

  return handler(index)
}

export const DELIMITER = '…'
